import React from "react";
import { useHistory } from "react-router-dom";
import Button from "../../UI/Button";

const NotFound = () => {
  const history = useHistory();

  const handleGoHomeClick = () => {
    history.push("/");
  };

  return (
    <div className="w-full h-screen flex flex-col screenVC:flex-row justify-center items-center">
      <div className="flex justify-center items-center gap-4 px-8 w-full">
        <h3 className="text-xl sm:text-3xl whitespace-nowrap">404 Not Found</h3>
        <Button
          className="bg-green-700 whitespace-nowrap w-min"
          onClick={handleGoHomeClick}
        >
          Go Home
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
